<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0072_invetory_report_check</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize" style="margin-bottom:20px;">
          <title-and-slot title="棚卸報告確認" ></title-and-slot>
          <div class="">
            <div style="margin-bottom:20px;margin-top:30px;float:left;">　　　　　　会社：</div>
            <select 
            style="margin-top:30px;display: inline;width: 300px;height: 24px;padding: 0 6px;" 
            class="form-control select-box"
            v-model="selectedcompany">
              <option v-if="EditableUser == true"></option>
              <option v-for="r in companylist" :key="r.value" :value="r.value">{{r.value}}</option>

            </select>
            <div class="">
            <br>
            </div>
            <div style="margin-bottom:20px;float:left;">棚卸報告年度区分：</div>
            <select 
            style="display: inline;width: 300px;height: 24px;padding: 0 6px;" 
            class="form-control select-box"
            :value = "selvalues['reporting_period']"
            @change="onSelectPeriod($event.target.value)">
              <option></option>
              <option v-for="r in reportingPeriodList" :key="r.value" :value="r.value">{{r.value}}</option>
            </select>
          </div>
        <div v-if="EditableUser == true">
          <div v-if = "withinperiod == false && admineditable && viewcaution" class="row">
            <font color="red">
            報告期間外です
            </font>
          </div>
          <div v-else-if = "withinperiod && admineditable == false && viewcaution" class="row">
            <font color="red">
            報告がロックされています
            </font>
          </div>
          <div v-else-if = "withinperiod == false && admineditable == false && viewcaution" class="row">
            <font color="red">
            報告がロックされており期間外です
            </font>
          </div>
          <div v-else class="row">
          　　
          </div>          
        </div>
          <div class="">
            <br>
          <tabs nav-style="tabs" @active="onTabChanged($event)" :value="selectedTab">
            <tab header="EUC /その他" ></tab>
            <tab header="IT所管システム" ></tab>
            <tab header="棚卸申請承認" v-if="InventoryApprovalInquiry > 0"></tab>
          </tabs>
          </div>
          <div class="" v-if="EditableUser == true && selectedTab != 2">
            <br>
          <report-totals-box tag="reportTotalsBox"/>
          <br>
          </div>

          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <div style="margin-top:5px;" v-if="selectedTab != 2">
            <br>

          <div v-if="rejectmode == true">
          <div class="row">
            <textarea  
                rows="3"
                class="form-control"
                style="float:right;margin-bottom:10px;margin-right:15px;height:100px;width:500px;resize: none"
                v-model="RejectReasonText"></textarea>
          </div>
                <div class="row" style="text-align:end;margin-bottom:10px">
                  <font color="red">
                  ※差戻理由を入力し、入力完了をクリックしてください。(任意)
                  </font>
                </div>
                <button
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;;background: #337ab7;" 
                :disabled="disablePageReject"
                @click="onRejectEmbedded"
                >{{RejectSaveText}}</button>
                <button 
                :disabled="false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #A6A6A6;" 
                @click="rejectcancelbtn"
                >ｷｬﾝｾﾙ</button>
          </div>
          <div v-if="rejectmode == false">
          <!-- <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button> -->
          <button
          v-if="EditableUser == true"
          :disabled="disableUnreportList || formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
          class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;"
          @click="initExportFile" >出力</button>
              <button
            v-if="EditableUser == true"
            :disabled="disableUnreportList"
            class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:10px;" @click="ShowUnreportList" >報告リスト</button>
          <button
              v-if="EditableUser == true && this.admineditable == true"
              :disabled="disablePageReject"
              @click="onRejectStart"
              class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:10px;background: #FF7C80;border-color:#FF7C80;">{{RejectText}}</button> 
          </div>
          </div>
        </div>
      <div v-if="EditableUser == true">  
        <inventory-unreport-list-euc tag="showinventoryunreportlisteuc" @done="onlisteucFile"></inventory-unreport-list-euc>
        <inventory-unreport-list-it tag="showinventoryunreportlistit" @done="onlistitFile"></inventory-unreport-list-it>
      </div>
      <confirmation-modal tag="confirminventorycheckonRejectEmbedded" @done="onReject" />
      <confirmation-modal tag="confirminventorycheckonRejectEmbeddednotification" @done="onRejectEnd"/>
  
      <file-download-modal tag="runinventoryreportlistDownloadModal" @close="onCloseExportFile"/>

    </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus'
import _ from 'lodash';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_inventory_report';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import reportTotalsBox from '@/components/report_totals_box';
import inventoryunreportlisteuc from '@/components/modals/inventory-unreport-list-euc';
import inventoryunreportlistit from '@/components/modals/inventory-unreport-list-it';
import fileDownloadModal from '@/components/modals/file-download-modal';
import constants from "@/rules/constants";
import { tab, tabs } from "vue-strap/dist/vue-strap.js";


export default {
  mixins: [
    mixinPageCommon,
    mixinDatasource,
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    "report-totals-box":reportTotalsBox,
    "inventory-unreport-list-euc":inventoryunreportlisteuc,
    "inventory-unreport-list-it":inventoryunreportlistit,
    'file-download-modal':fileDownloadModal,
    tab, 
    tabs
  },
  data() {
    return {
      selected_tab:0,
      api_name:"inventory_report",
      detail_page:"page_0071_inventory_report",
      page_acl: acl.inventory_report_check,
      execute_filter_on_back:true,
      inventory_approval_inquiry:-1,
      reporting_period_list:[],
      selected_company:false,
      admin_editable:true,
      within_period:true,
      rejectmode:false,
      company_list:[],
      load_count:0,
      userID:"",
      RejectReasonText:"",
      def_subsearch:{},
      make_need_submit_List:false,
      inventory_sub_search:{reporting_period:false,company:false,jurisdiction_classification:"EUC・その他"},
    };
  },
  computed: {
    selvalues(){
      return this.inventory_sub_search;
    },
    RejectText(){
      if(this.disablePageReject){
        return "差戻";
      }else{
        return "差戻 (" + this.formOutputQty + ")";
      }
    },
    RejectSaveText(){
      if(this.disablePageReject){
        return "入力完了";
      }else{
        return "入力完了 (" + this.formOutputQty + ")";
      }
    },
    loadcount:{
      get(){
        return this.load_count;
      },
      set(v){
        this.load_count = v;
      }
    },
    viewcaution(){
      return (this.inventory_sub_search.reporting_period != "" 
      && this.inventory_sub_search.reporting_period != false);
    },    
    InventoryApprovalInquiry:{
      get(){
        //常時表示に変更
        // return this.inventory_approval_inquiry;
        return true;
      },
      set(v){
        this.inventory_approval_inquiry = v;
      }
    },
    disablePageReject:{
      get(){
        //TODO:選択対象の状態
        // if(this.approveMode !="reject"){
        //   return true;
        // }
        if(this.formOutputQty == 0 ){
          return true;
        }else{
          return false;
        }
        // return this.disable_page_approve;
      },
      set(v){
        this.disable_page_approve = v;
      }
    },
    admineditable:{
      get(){
        return this.admin_editable;
      },
      set(v){
        this.admin_editable = v;
      }
    },
    withinperiod:{
      get(){
        return this.within_period;
      },
      set(v){
        this.within_period = v;
      }
    },
    EditableUser(){
      return ((Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR 
      || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF))
      && Vue.localStorage.get("userCompany") == "ライセンス管理窓口";
    },
    disableUnreportList(){
      return this.inventory_sub_search.reporting_period == false || this.inventory_sub_search.company == false || this.inventory_sub_search.jurisdiction_classification == false;
    },
    selectedcompany:{
      get(){
        return this.selected_company ;
      },
      set(v){
        this.clearmode();
        this.selected_company = v;
        this.inventory_sub_search.company = v;
        Vue.localStorage.set(this.userID + "_inventory_report_company",v);        
        if(typeof this.inventory_sub_search.reporting_period != "undefined" && this.inventory_sub_search.reporting_period != ""){
          if(v==""){
            if(this.inventory_sub_search.jurisdiction_classification != "棚卸申請承認"){
              this.searchControlChangedDatasource(this.singleSearchCreate("jurisdiction_classification",this.inventory_sub_search.jurisdiction_classification));
            }else{
              this.searchControlChangedDatasource(this.singleSearchCreate("reporting_period",this.inventory_sub_search.reporting_period));
            }
          }else{
            this.searchControlChangedDatasource(this.singleSearchCreate("company","" + v));
          }
        }
        this.uptReportTotalsBox(false,()=>{
          this.loadReportTotalsBox();
          this.autoSizeAll();
        });
        setTimeout(()=>{
          this.autoSizeAll();
        },1000)
      }
    },
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
    companylist:{
      get(){
        return this.company_list;
      },
      set(v){
        this.company_list = v;
      }
    },
    reportingPeriodList:{
      get(){
        return this.reporting_period_list;
      },
      set(v){
        this.reporting_period_list = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    allSearchFields(){
      return [
          fields.approval_status,
          fields.device_control_number,
          fields.registration_date,
          fields.computer_name,
          fields.equipment_in_charge_department,
          fields.equipment_in_charge_team,
          fields.equipment_in_charge_classification,
          fields.equipment_in_charge_system,
          fields.installation_department,
          fields.installation_team,
          fields.user_name,
          fields.management_person_name,
      ]
    },
    tabFieldList() {
        return [
          
          utils.extend(fields.approval_status, {tab_size:60}),
          utils.extend(_.clone(fields.company), {tab_size:60}),
          // utils.extend(fields.reporting_system, {}),
          utils.extend(fields.team_in_charge, {tab_size:82}),
          utils.extend(_.clone(fields.department_in_charge),{tab_size:60}),
          utils.extend(fields.created_date, {tab_size:60}),
          utils.extend(fields.last_update_date, {tab_size:52}),
          utils.extend(fields.created_by_label, {tab_size:52}),
          utils.extend(fields.contact_person, {tab_size:52}),
          utils.extend(fields.ledger_check, {tab_size:247}),
          utils.extend(fields.new_registration_of_equipment, {tab_size:112}),
          utils.extend(fields.change_device_information, {tab_size:112}),
          utils.extend(fields.disposal_of_device_information, {tab_size:112}),
          utils.extend(fields.certificate_list_check, {tab_size:112}),
          utils.extend(fields.new_license_registration, {tab_size:157}),
          utils.extend(fields.change_license_information, {tab_size:247}),
          utils.extend(fields.disposal_of_license, {tab_size:127}),
          utils.extend(fields.lack_of_license, {tab_size:187}),
          utils.extend(fields.lost_license_certificate, {tab_size:172}),
          utils.extend(fields.no_evidence_of_license_receipt, {tab_size:232}),
          utils.extend(fields.other, {tab_size:70}),
          utils.extend(fields.remarks, {tab_size:157}),
          utils.extend(fields.certificate_list_check, {tab_size:112}),
          utils.extend(fields.new_license_registration, {tab_size:157}),
          utils.extend(fields.change_license_information, {tab_size:157}),
          utils.extend(fields.disposal_of_license, {tab_size:127}),
          utils.extend(fields.unused_license, {tab_size:127}),
          utils.extend(fields.reason_not_using, {tab_size:172}),
          utils.extend(fields.expired_license, {tab_size:142}),
          utils.extend(fields.expired_license_support, {tab_size:172}),
          utils.extend(fields.certificate_remarks, {tab_size:97}),
          utils.extend(fields.linkage_ratio, {tab_size:60}),
          utils.extend(fields.number_of_registered_devices, {tab_size:100}),
          utils.extend(fields.number_of_registered_licenses, {tab_size:120}),
          utils.extend(fields.number_of_software_packages_used, {tab_size:138}),
          utils.extend(fields.number_of_installed_software_to_be_linked, {tab_size:230}),
          utils.extend(fields.number_of_installation_software_licenses_attached, {tab_size:250}),
        ];
    },
    tabFieldList2() {
        return [
          utils.extend(fields.approval_status, {tab_size:60}),
          utils.extend(_.clone(fields.company), {tab_size:60}),
          utils.extend(fields.reporting_system, {tab_size:97}),
          // utils.extend(fields.team_in_charge, {tab_size:82}),
          utils.extend(_.clone(fields.department_in_charge),{tab_size:60}),
          utils.extend(fields.created_date, {tab_size:60}),
          utils.extend(fields.last_update_date, {tab_size:52}),
          utils.extend(fields.created_by_label, {tab_size:52}),
          utils.extend(fields.contact_person, {tab_size:52}),
          utils.extend(fields.ledger_check, {tab_size:247}),
          utils.extend(fields.new_registration_of_equipment, {tab_size:112}),
          utils.extend(fields.change_device_information, {tab_size:112}),
          utils.extend(fields.disposal_of_device_information, {tab_size:112}),
          utils.extend(fields.certificate_list_check, {tab_size:112}),
          utils.extend(fields.new_license_registration, {tab_size:157}),
          utils.extend(fields.change_license_information, {tab_size:247}),
          utils.extend(fields.disposal_of_license, {tab_size:127}),
          utils.extend(fields.lack_of_license, {tab_size:187}),
          utils.extend(fields.lost_license_certificate, {tab_size:172}),
          utils.extend(fields.no_evidence_of_license_receipt, {tab_size:232}),
          utils.extend(fields.other, {tab_size:70}),
          utils.extend(fields.remarks, {tab_size:157}),
          utils.extend(fields.certificate_list_check, {tab_size:112}),
          utils.extend(fields.new_license_registration, {tab_size:157}),
          utils.extend(fields.change_license_information, {tab_size:157}),
          utils.extend(fields.disposal_of_license, {tab_size:127}),
          utils.extend(fields.unused_license, {tab_size:127}),
          utils.extend(fields.reason_not_using, {tab_size:172}),
          utils.extend(fields.expired_license, {tab_size:142}),
          utils.extend(fields.expired_license_support, {tab_size:172}),
          utils.extend(fields.certificate_remarks, {tab_size:97}),
          utils.extend(fields.linkage_ratio, {tab_size:60}),
          utils.extend(fields.number_of_registered_devices, {tab_size:100}),
          utils.extend(fields.number_of_registered_licenses, {tab_size:120}),
          utils.extend(fields.number_of_software_packages_used, {tab_size:138}),
          utils.extend(fields.number_of_installed_software_to_be_linked, {tab_size:230}),
          utils.extend(fields.number_of_installation_software_licenses_attached, {tab_size:250}),

        ];
    },
    tabFieldList3() {
      return [
        utils.extend(fields.approval_status, {
          search_no_blank:true,tab_size:60
        }),
        utils.extend(_.clone(fields.company),),
        utils.extend(_.clone(fields.department_in_charge),),
        utils.extend(fields.team_in_charge,),
        utils.extend(_.clone(fields.jurisdiction_classification),),
        utils.extend(fields.reporting_system, {}),        
        utils.extend(fields.applicant_label, {}),
        utils.extend(fields.next_approver_label, {}),
        utils.extend(fields.create_time, {}),

        // utils.extend(fields.update_time, {}),
    utils.extend(fields.approver_1_label, {tab_size:100}),
        utils.extend(fields.status_1, {tab_size:60}),
        utils.extend(fields.approver_2_label, {tab_size:100}),
        utils.extend(fields.status_2, {tab_size:60}),
        utils.extend(fields.approver_3_label, {tab_size:100}),
        utils.extend(fields.status_3, {tab_size:60}),
        utils.extend(fields.approver_4_label, {tab_size:100}),
        utils.extend(fields.status_4, {tab_size:60}),
        utils.extend(fields.approver_5_label, {tab_size:100}),
        utils.extend(fields.status_5, {tab_size:60}),
        utils.extend(fields.approver_6_label, {tab_size:100}),
        utils.extend(fields.status_6, {tab_size:60}),
        utils.extend(fields.approver_7_label, {tab_size:100}),
        utils.extend(fields.status_7, {tab_size:60}),
        utils.extend(fields.approver_8_label, {tab_size:100}),
        utils.extend(fields.status_8, {tab_size:60}),
        utils.extend(fields.approver_9_label, {tab_size:100}),
        utils.extend(fields.status_9, {tab_size:60}),
        utils.extend(fields.approver_10_label, {tab_size:100}),
        utils.extend(fields.status_10, {tab_size:60}),
        utils.extend(fields.approver_11_label, {tab_size:100}),
        utils.extend(fields.status_11, {tab_size:60}),
        utils.extend(fields.approver_12_label, {tab_size:100}),
        utils.extend(fields.status_12, {tab_size:60}),
        utils.extend(fields.approver_13_label, {tab_size:100}),
        utils.extend(fields.status_13, {tab_size:60}),
        utils.extend(fields.approver_14_label, {tab_size:100}),
        utils.extend(fields.status_14, {tab_size:60}),
        utils.extend(fields.approver_15_label, {tab_size:100}),
        utils.extend(fields.status_15, {tab_size:60}),
        utils.extend(fields.approver_16_label, {tab_size:100}),
        utils.extend(fields.status_16, {tab_size:60}),
        utils.extend(fields.approver_17_label, {tab_size:100}),
        utils.extend(fields.status_17, {tab_size:60}),
        utils.extend(fields.approver_18_label, {tab_size:100}),
        utils.extend(fields.status_18, {tab_size:60}),
        utils.extend(fields.approver_19_label, {tab_size:100}),
        utils.extend(fields.status_19, {tab_size:60}),
        utils.extend(fields.approver_20_label, {tab_size:100}),
        utils.extend(fields.status_20, {tab_size:60}),
        
      ];
    },
    searchkeys(){
      return [
        "reporting_period",
        "company", 
        "jurisdiction_classification",
        ]
    },
  },
  methods: {
    clearmode(){
      this.rejectmode = false;
    },
    inventory_admin_edit(){
      if(typeof this.inventory_sub_search["reporting_period"] != "undefined" && this.inventory_sub_search["reporting_period"] != ""){
      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/",{reporting_period:this.inventory_sub_search["reporting_period"]},(err, result) => {
          if (err) {
              this.$notify({
                title: "棚卸編集可能データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }else{
              if(result.editable=="許可"){
                this.admineditable = true;
              }else{
                this.admineditable = false;
              }

            };
        });
      }
    },
    onlisteucFile(mode){
      if(mode == "yes"){
        var filter =          {
            "1":{block: "1", field: "reporting_period", value: this.inventory_sub_search.reporting_period, ct: "v", ca: false, t: "input"},
            "2":{block: "2", field: "company", value: this.inventory_sub_search.company, ct: "v", ca: false, t: "input"},
            "3":{block: "3", field: "jurisdiction_classification", value: this.inventory_sub_search.jurisdiction_classification, ct: "v", ca: false, t: "input"},
            // "2":false,
            // "3":false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          };
        //FILE_EXPORT_PART2 : Step 2
        bus.$emit("runinventoryreportlistDownloadModal",{
          message: "ファイルを出力しています。",
          on_complete_message:"出力が完了しました。",
          title: "出力",
          sub_search : this.inventory_sub_search,
          filter: filter,
          // sort: this.last_data_source_sort,
          url:"/inventory_unreport_list/export_report_data/"
        });
      }
    },
    onRejectStart(){ 
      this.RejectReasonText = "";
      this.rejectmode = true;
    },
    rejectcancelbtn(){
      this.rejectmode = false;
    },
    onRejectEmbedded(){    
      // var qty = this.loadSelectedApprovalHistory().length;
      bus.$emit("confirminventorycheckonRejectEmbedded", {
        // title: "選択中　"+qty+"件",
        title:"",
        message: "申請を差戻します。よろしいですか？",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
      });
    },
    onlistitFile(mode){
      if(mode == "yes"){
        var filter =          {
            "1":{block: "1", field: "reporting_period", value: this.inventory_sub_search.reporting_period, ct: "v", ca: false, t: "input"},
            "2":{block: "2", field: "company", value: this.inventory_sub_search.company, ct: "v", ca: false, t: "input"},
            "3":{block: "3", field: "jurisdiction_classification", value: this.inventory_sub_search.jurisdiction_classification, ct: "v", ca: false, t: "input"},
            // "2":false,
            // "3":false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          };
        //FILE_EXPORT_PART2 : Step 2
        bus.$emit("runinventoryreportlistDownloadModal",{
          message: "ファイルを出力しています。",
          on_complete_message:"出力が完了しました。",
          title: "出力",
          sub_search : this.inventory_sub_search,
          filter: filter,
          // sort: this.last_data_source_sort,
          url:"/inventory_unreport_list/export_report_data/"
        });
      }
    },
    initExportFile(){
      if(this.selectedTab == 0){
          var url = "/inventory_report/export_report_data_euc/"
        }else{
          var url = "/inventory_report/export_report_data_it/"        
        }
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runinventoryreportlistDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        sub_search : this.inventory_sub_search,
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:url
      });
    },
    onCloseExportFile(){},
    ShowUnreportList(){
      if(this.selectedTab == 0){
        return bus.$emit("showinventoryunreportlisteuc",{
          title: "報告「部署」・「チーム」",
          send_subsearch:this.inventory_sub_search,
        });
      }else{
        return bus.$emit("showinventoryunreportlistit",{
          title: "報告「システム」",
          send_subsearch:this.inventory_sub_search,
        });
      }
    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      var force_return_jurisdiction_classification = "";
      if(this.inventory_sub_search.jurisdiction_classification == "棚卸申請承認"){
        force_return_jurisdiction_classification = "棚卸申請承認";
      }
      window.sessionStorage.setItem('device_back_to_list_name', 'page_0072_inventory_report_check')
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id , force_return_jurisdiction_classification:force_return_jurisdiction_classification } });
    },
    onTabChanged(index) {
      this.clearmode();
      this.clearSearchFields();
      this.selectedTab = index;
      this.set_jurisdiction_classificationFromTab();


      if(index == 0){
        Vue.localStorage.set(this.userID + "_inventory_report_jurisdiction_classification",this.inventory_sub_search.jurisdiction_classification);
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      }else if(index == 1){
        Vue.localStorage.set(this.userID + "_inventory_report_jurisdiction_classification",this.inventory_sub_search.jurisdiction_classification);
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      }else{
        Vue.localStorage.set(this.userID + "_inventory_report_jurisdiction_classification","棚卸申請承認");
        this.gridOptions.suppressHorizontalScroll = true;
        this.gridOptions.suppressSizeToFit = false;
        this.gridOptions.api.setColumnDefs(this.createColumnDefs());
      }
      
      // this.autoSizeAll();
      this.uptReportTotalsBox(false,()=>{
        if(this.inventory_sub_search.reporting_period == false){
          this.loadReportTotalsBox();
        }else{
          this.onSelectPeriod(this.inventory_sub_search.reporting_period)
        }
      });
      setTimeout(()=>{
          this.autoSizeAll();
      },1500)
    },
    onSelectPeriod(p){
      this.clearmode();
      this.inventory_sub_search.reporting_period = p;
      if(p == ""){
        this.admineditable = true;
        this.withinperiod = true;
      }
      //報告リスト更新フラグ
      this.make_need_submit_List = true;
      Vue.localStorage.set(this.userID + "_inventory_report_reporting_period", p);
      this.searchControlChangedDatasource(this.singleSearchCreate("reporting_period","" + p))
      this.uptReportTotalsBox(false,()=>{
        this.loadReportTotalsBox();
        this.autoSizeAll();
      });
      setTimeout(()=>{
       this.autoSizeAll();
      },1000)
    },
    set_jurisdiction_classificationFromTab(){
      switch(this.selectedTab){
        case 0:
            this.inventory_sub_search.jurisdiction_classification = "EUC・その他"
            break;
        case 1:
            this.inventory_sub_search.jurisdiction_classification = "IT所管システム"
            break; 
        case 2:
            this.inventory_sub_search.jurisdiction_classification = "棚卸申請承認"
            break;                    
      }
    },
    get_jurisdiction_classificationTabIndex(jurisdiction_classification){
      switch(jurisdiction_classification){
        case "EUC・その他" :
          return 0;
          break;
        case "IT所管システム" :
          return 1;
          break;          
        case "棚卸申請承認" : 
          return 2;
          break;
        default:
          return 0;
          break;
      }
    },
    createColumnDefs() {
      switch(this.selectedTab){
        case 0:
          var field_list_name = "tabFieldList";
          var show_checkbox = true;
          var force_sort = {id:"last_update_date",direction:"desc"}
            break;
        case 1:
          var field_list_name = "tabFieldList2";
          var show_checkbox = true;
          var force_sort = {id:"last_update_date",direction:"desc"}
            break; 
        case 2:
          var field_list_name = "tabFieldList3";
          var show_checkbox = false;
          var force_sort = {id:"approval_status",direction:"desc"}
            break;                    
      }
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:show_checkbox,field_list_name,force_sort:force_sort})
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    backToList(){
      return this.$router.push({ path: '/inventory_management', params: {} });
    },
    loadReportTotalsBox(){

      if(typeof this.inventory_sub_search["reporting_period"] != "undefined" && this.inventory_sub_search["reporting_period"] != ""){
      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/",{reporting_period:this.inventory_sub_search["reporting_period"]},(err, result) => {
          if (err) {
              this.$notify({
                title: "棚卸編集可能データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }else{
              if(result.editable=="許可"){
                this.admineditable = true;
              }else{
                this.admineditable = false;
              }
              if(this.EditableUser == false || this.selectedTab == 2 ){
                return;
              }
              //期間内かどうか判定
              this.$ajax.post("/" + this.api_name + "/inventory_period_inquiry/",{reporting_period:this.inventory_sub_search["reporting_period"]},(err, result) => {
                if (err) {
                    this.$notify({
                      title: "棚卸期間データの読込に失敗しました。",
                      text: err,
                      type: "error",
                      duration: 10000,
                    });
                    return;
                  }else{
                    if(result.qty>0){
                      this.withinperiod = true;

                    }else{
                      this.withinperiod = false;
                    }

                    //報告リストを更新するか判定               
                    var Local_make_need_submit_List_flag = false;
                    if(this.make_need_submit_List==true && this.admineditable == true && this.withinperiod == true){
                      this.make_need_submit_List = false;
                      Local_make_need_submit_List_flag = true;
                    }
                    this.loadcount += 1;
                    var current = this.loadcount;
                    this.$ajax.post("/" + this.api_name + "/get_reporting_totals_for_period",{sub_search:this.inventory_sub_search,make_need_submit_List:Local_make_need_submit_List_flag}, (err, data) => {
                      if(this.loadcount==current){
                        this.uptReportTotalsBox(data || {})
                      }
                    });

                  }
              });
            };
        });
      }


    },

    uptReportTotalsBox(val=false, cb=()=>{}){
      if(val==false){
          val = {
          reportable_team: "",
          number_of_reports: "",
          unreported_number: "",
          report_rate: "",
          lack_of_license: "",
          lost_license_certificate: "",
          no_evidence_of_license_receipt: "",
          other: "",
          number_of_items_to_be_linked: "",
          total_number_of_pegging: "",
          linking_rate: "",
        }
      }
      bus.$emit("reportTotalsBox", val);
      cb()
    },
    // cellStyle(params) {
    //   if(params.data){
    //     if(params.data.has_error){
    //       if(params.data.error_type && typeof params.data.error_type == "string"){
    //         params.data.error_type = JSON.parse(params.data.error_type)
    //       }
    //       if(params.data.error_link && typeof params.data.error_link == "string"){
    //         params.data.error_link = JSON.parse(params.data.error_link)
    //       }
    //     }
    //     if(_.find(params.data.error_type,(f)=>{return f.field_id == params.colDef.field })){
    //       return {color:'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)'};
    //     }else if(_.find(params.data.error_link,(f)=>{return f.field_id == params.colDef.field })){
    //       return {color:'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)'};
    //     }else{
    //       return null;
    //     }

    //   }
    // },
    // onRowSelected(params) {
    //   this.selected_row = params.node.data.seq_id;
    //   this.showErrros(params.node.data)
    // },
    // showErrros(data){
    //   if(data.has_error != 1){
    //     this.showErrroCount();
    //     return;
    //   }
    //   var error = "";
    //   if(Array.isArray(data.error_type) && data.error_type.length > 0 ){
    //     data.error_type.forEach(e=>{
    //       if(e.error_header){
    //         // Don't need to add a new header
    //       }else{
    //         error +=  ""+e.cell+"列"+e.row_no+"行 目の "+e.field_label+"　"
    //       }
    //       error += "" + e.error + "<br><br>"
    //     })
    //   }
    //   if(Array.isArray(data.error_link) && data.error_link.length > 0 ){
    //     data.error_link.forEach(e=>{
    //       if(e.error_header){
    //         // Don't need to add a new header
    //       }else{
    //         error +=  ""+e.cell+"列"+e.row_no+"行 目の "+e.field_label+"　"
    //       }
    //       error += "" + e.error + "<br><br>"
    //     })
    //   }
    //   this.$emit("onerror",error)
    // },
    onReject(mode){
      if(mode != "yes"){
        return;
      }
      
      var arr = this.selectedRowArr.map((m)=>{
          return {
              a_seq_id:m.a_seq_id,
              seq_id:m.seq_id,
              retraction_reason:this.RejectReasonText,
          };
        });
      
      var hash = 0;
      arr.forEach(e =>{
        hash = hash + ((e.seq_id + 3) * 2) // Simple hash to avoid direct request
      })

      this.$ajax.post("/" + this.api_name + "/admin_reject/" , {arr,hash}, (err, response) => {
          if(err){
          this.$notify({
              title: "差戻に失敗しました",
              text:err,
              type: "error",
              duration: 10000
            });
          }else{
              // this.gridOptions.api.purgeInfiniteCache();
              // this.formOutputQty = 0;
              // this.selectedRowArr = [];
              var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";    
              bus.$emit("confirminventorycheckonRejectEmbeddednotification",{
                message: message,
                title: "申請が差戻されました",
                yes_label: "",
                no_label: "OK",
                yes_color:"",
                no_color:"",
                model_height:"50",
                model_width: "390px"
                });
        }
      });

    },
    onRejectEnd(){
      //リフレッシュ方法が分からないので強引手法
      var temp = this.inventory_sub_search.reporting_period;
      this.onSelectPeriod("");
      this.onSelectPeriod(temp);
           
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    },
    updateListSelectBox(){

    // this.$ajax.post("/" + this.api_name + "/inventory_approval_inquiry",{}, (err, data) => {
      
    //   this.InventoryApprovalInquiry = data.qty || 0;
    //     if(this.InventoryApprovalInquiry == 0 && this.selectedTab ==2){
    //       this.onTabChanged(0);
    //       this.set_jurisdiction_classificationFromTab();
    //     }


        this.$ajax.post("/master_inventory_reporting_period/list_reporting_period", {}, (err, data) => {
            if (err) {
              this.$notify({
                title: "報告期分が読み込めませんでした",
                text: err,
                type: "error",
                duration: 10000,
              });
            }
          data.forEach(d=>{
            d.value =d.val;
          })
          this.reportingPeriodList = data;
            this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
                var refreshflag = 0;
                _companies.forEach(d=>{
                    d.value =d.val;
                  })
                this.companylist = _companies;
                if(this.EditableUser == false){
                  for(var k in this.companylist){
                    this.selectedcompany = this.companylist[k].val;
                    refreshflag += 1;
                    break;
                  }
                }else{
                  if(typeof this.def_subsearch["company"] != "undefined" 
                  && this.def_subsearch["company"] != "" ){
                      this.selected_company = this.def_subsearch["company"];
                      this.inventory_sub_search.company = this.def_subsearch["company"];
                      refreshflag += 1;
                  }
                }
                if(typeof this.def_subsearch["reporting_period"] != "undefined" 
                  && this.def_subsearch["reporting_period"] != "" ){
                  setTimeout(()=> {  
                    this.selvalues['reporting_period'] = this.def_subsearch["reporting_period"];
                  },200)
                  refreshflag += 1;
                }
                 setTimeout(()=> {  
                 this.uptReportTotalsBox(false,()=>{
                   this.loadReportTotalsBox();
                   this.autoSizeAll();
                  });
                  },400)
                if(refreshflag >= 2){
                  setTimeout(()=> {
                    // this.searchControlChangedDatasource(this.singleSearchCreate("jurisdiction_classification",this.inventory_sub_search.jurisdiction_classification));
                    this.searchControlChangedDatasource(this.singleSearchCreate("reporting_period",this.inventory_sub_search.reporting_period));
                  },1000)
                }
                setTimeout(()=>{
                  this.autoSizeAll();
                },1500)


            });
        });
      // });
    },
    autoSizeAll(skipHeader) {
        // if(this.selectedTab!=2){
          setTimeout(() => {
            var allColumnIds = [];
            this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
              allColumnIds.push(column.colId);
            });
            var allColumnIds_Except = ["approval_status","company","number_of_registered_devices","number_of_registered_licenses","number_of_software_packages_used","number_of_installed_software_to_be_linked","number_of_installation_software_licenses_attached",
            "lack_of_license","lost_license_certificate","no_evidence_of_license_receipt","other","disposal_of_license","change_license_information",
            "new_license_registration","certificate_list_check","disposal_of_device_information","change_device_information","new_registration_of_equipment","ledger_check"];

            var resizecolumns = allColumnIds.filter(n => allColumnIds_Except.includes(n) == false);
            this.gridOptions.columnApi.autoSizeColumns(resizecolumns, false);
          }, 100);
        // }else{
        //   setTimeout(() => {
        //   this.gridOptions.api.sizeColumnsToFit();
        //   }, 100);
        // }
    },
    localInitLoadData(){
    },
  },
  mounted() {
    this.updateListSelectBox();

  },
  beforeMount() {

      this.make_need_submit_List = true;
      this.userID = Vue.localStorage.get("userID");
      this.$store.state[this.stateCurrentRow]= {};
      var map = this.searchkeys;

      for(var k in map){
        if(typeof Vue.localStorage.get(this.userID + "_inventory_report_" + map[k]) != "undefind" && Vue.localStorage.get(this.userID + "_inventory_report_" + map[k]) != ""){   
          this.def_subsearch[map[k]] = Vue.localStorage.get(this.userID + "_inventory_report_" + map[k]) || "";
        }
          if(this.$route.params.sub_search){
            if(typeof this.$route.params.sub_search[map[k]] != "undefind" && this.$route.params.sub_search[map[k]] != ""){
              this.def_subsearch[map[k]] = this.$route.params.sub_search[map[k]]
            }
          }
      }
      
    if(typeof this.def_subsearch["jurisdiction_classification"] != "undefind" && this.def_subsearch["jurisdiction_classification"] != ""){
       var tabnumber = this.get_jurisdiction_classificationTabIndex(this.def_subsearch["jurisdiction_classification"]);
       this.selected_tab = tabnumber;
    }

    this.api_request_options = {sub_search:"inventory_sub_search"};

    this.set_jurisdiction_classificationFromTab();
    // if(this.selected_tab!=2){
      this.gridOptions = _.extend(this.commonGridOptions, {suppressHorizontalScroll: false,suppressSizeToFit : false});
    // }else{
    //   this.gridOptions = _.extend(this.commonGridOptions, {suppressHorizontalScroll: true,suppressSizeToFit : true});
    // }
    this.initDatasource({load_only_with_filter:true});


  },
  beforeDestroy() {
  },
};

</script>
<style scoped>
.line1{
    height: 25px;
    width: 150px;
    margin-left: 10px;
}
.textbox{
    height: 25px;
    width: 150px;
    border-radius: 5px;
    border-width: thin;
}
</style>


// WEBPACK FOOTER //
// page_0072_inventory_report_check.vue?231048e9